import { Alert, Box, Button, CircularProgress, List, ListItem, ListItemText, Paper, TextField, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import apiClient from '../api/client';
import Layout from '../components/Layout';
import OrganizationMembers from '../components/OrganizationMembers';
import { useAuth } from '../contexts/AuthContext';
import { useRealtimeSSE } from '../hooks/useRealtimeSSE';

const OrganizationsPage = () => {
  const { organizations, currentOrg, changeOrg } = useAuth();

  // ✅ Подключение к SSE для real-time обновлений
  useRealtimeSSE();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [name, setName] = useState('');
  const [orgs, setOrgs] = useState(organizations);

  useEffect(() => {
    setOrgs(organizations);
  }, [organizations]);

  const handleCreate = async () => {
    if (!name.trim()) return;
    setLoading(true);
    try {
      const res = await apiClient.post('/organizations', { name });
      const newOrg = res.data;
      setOrgs(prev => [...prev, newOrg]);
      changeOrg(newOrg.id);
      setName('');
      setError('');
    } catch (err) {
      console.error(err);
      setError('Не удалось создать организацию');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout>
      <Box sx={{ p: 3 }}>
        <Typography variant="h4" gutterBottom>
          Организации
        </Typography>
        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
        <Paper sx={{ p: 2, mb: 2, display: 'flex', gap: 2 }}>
          <TextField
            fullWidth
            label="Название организации"
            value={name}
            onChange={e => setName(e.target.value)}
          />
          <Button
            variant="contained"
            onClick={handleCreate}
            disabled={loading}
          >
            {loading ? <CircularProgress size={24} /> : 'Создать'}
          </Button>
        </Paper>
        <List>
          {orgs.map(org => (
            <ListItem
              key={org.id}
              secondaryAction={
                <Button
                  size="small"
                  variant={org.id === currentOrg ? 'contained' : 'outlined'}
                  onClick={() => changeOrg(org.id)}
                >
                  {org.id === currentOrg ? 'Текущая' : 'Выбрать'}
                </Button>
              }
            >
              <ListItemText
                primary={org.name}
                secondary={`ID: ${org.id}`}
              />
            </ListItem>
          ))}
        </List>
        {currentOrg && <OrganizationMembers />}
      </Box>
    </Layout>
  );
};

export default OrganizationsPage; 